var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-select',{attrs:{"icon":_vm.icon,"label":_vm.label,"keys":{ label:'name', value: 'id' },"placeholder":_vm.placeholder,"options":_vm.options,"disabled":_vm.isLoading || _vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }